export default __webpack_public_path__ + "static/media/wasserkontamination.7a74f041.svg";